import React from "react";
import { Col, Button, InputGroup, Form, Row, Table } from "react-bootstrap";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

import { Header } from "./Header";
import { Sidebar } from "./Sidebar";
import { Settings } from "./Settings";
import { useEmailBuilderContext } from "../../../../Context/EmailBuilderContext";

export default function EmailBuilder() {
  const { formData } = useEmailBuilderContext();

  const onDragEnd = (result) => {
    // console.log("Result:", result);
  };

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <main className="main overflow-hidden">
        <div className="formeditor-wrapper shadow-1 box-shadow-3">
          <Header />

          <div className="d-flex rounded-bottom overflow-hidden align-items-start bg-white rounded-bottom-3 formbuilder-body">
            <Droppable droppableId="sidebar">
              {(provided) => (
                <div ref={provided.innerRef} {...provided.droppableProps}>
                  <Sidebar />
                </div>
              )}
            </Droppable>

            <div className="formeditor-view ms-auto sidebar-right p-3 border-end border-start h-100">
              <div className="p-3 rounded-2 bg-white border scroll-y">
                <div className="section-divider text-center mb-4">
                  <span className="bg-white">Add section header</span>
                </div>
                <Row className="row gy-4">
                  <Droppable droppableId="main" direction="vertical">
                    {(provided) => (
                      <div ref={provided.innerRef} {...provided.droppableProps}>
                        <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                          <div className="builder-row border rounded-2 bg-light">
                            <div className="builder-row-header py-2 px-3 border-bottom d-flex">
                              <h4>
                                <span className="material-symbols-outlined align-middle me-2">
                                  notes
                                </span>{" "}
                                Short text
                              </h4>
                              <div className="button-list ms-auto d-flex">
                                <Button variant="transparent">
                                  <span className="material-symbols-outlined copy-btn me-2">
                                    settings
                                  </span>
                                </Button>
                                <Button variant="transparent">
                                  <span className="material-symbols-outlined align-middle copy-btn me-2">
                                    content_copy
                                  </span>
                                </Button>
                                <Button variant="transparent">
                                  <span className="material-symbols-outlined align-middle remove-btn">
                                    delete
                                  </span>
                                </Button>
                              </div>
                            </div>
                            <div className="builder-row-body d-flex flex-wrap">
                              <div className="drag-btn d-flex justify-content-center align-items-center border-end">
                                <Button variant="transparent">
                                  <span className="material-symbols-outlined">
                                    drag_indicator
                                  </span>
                                </Button>
                              </div>
                              <div className="builder-field p-3">
                                <Form.Group
                                  className="mb-3"
                                  controlId="shorttext"
                                >
                                  <Form.Label>
                                    Add your Question here.
                                    <small className="d-block">
                                      This will help us ensure accurate
                                      communication and correspondence
                                      throughout the admission process.
                                    </small>
                                  </Form.Label>
                                  <Form.Control
                                    type="text"
                                    placeholder="Search element"
                                  />
                                </Form.Group>
                              </div>
                            </div>
                          </div>
                        </Col>
                      </div>
                    )}
                  </Droppable>
                </Row>
              </div>
            </div>

            <Settings />
          </div>
        </div>
      </main>
    </DragDropContext>
  );
}
